import { type LocationQuery } from 'vue-router'

/**
 * Routes listed here own their own full-page layout instead of using BaseView.
 *
 * @param routeName - Vue Router route name to inspect.
 * @returns Whether the brand route should bypass the default BaseView wrapper.
 */
export function isWrapperlessBrandRouteName(routeName: unknown): boolean {
  if (typeof routeName !== 'string') {
    return false
  }

  return (
    routeName.startsWith('brand.setup') ||
    routeName.startsWith('location.setup') ||
    routeName === 'brand.apps.customers' ||
    routeName === 'brand.apps.loyalty' ||
    routeName === 'brand.apps.orders' ||
    routeName === 'brand.inbox' ||
    routeName === 'brand.tools.phone-ordering' ||
    routeName === 'brand.tools.acceptance-document'
  )
}

/**
 * Whether the brand route is being embedded in another Owner app's iframe (e.g.
 * Hercules ships Hermes' Brand Status tool this way). When set, the brand view
 * drops all Hermes chrome — sidebar, admin banner, and the Owner agent widget —
 * so only the tool itself shows. Driven by an `embed=1` query param rather than
 * the route name, because these pages are also used normally inside Hermes.
 *
 * @param query - Current route query.
 * @returns Whether Hermes should render the page chrome-less for embedding.
 */
export function isEmbeddedRouteQuery(query: LocationQuery): boolean {
  return query.embed === '1'
}
